/**
 * Handles smooth animations for HTML5 <details> accordions
 * and div/button based accordions.
 */

class DetailsAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.product-info__accordion-content') || el.querySelector('summary ~ *');
    if (!this.summary || !this.content) return;

    this.targetOpen = this.el.open;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    if (this.targetOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.targetOpen = true;

    // Exclusivity: close other open accordions in the same container
    const parent = this.el.parentElement;
    if (parent) {
      const siblings = parent.querySelectorAll('details');
      siblings.forEach((sibling) => {
        if (sibling !== this.el && sibling._accordionInstance) {
          sibling._accordionInstance.close();
        }
      });
    }

    this.el.open = true;
    this.content.style.maxHeight = '0px';
    this.content.style.opacity = '0';
    this.content.style.overflow = 'hidden';
    this.content.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';

    // Tiny timeout to let browser register open display
    setTimeout(() => {
      if (!this.targetOpen) return;
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      this.content.style.opacity = '1';
    }, 10);

    // Clean up styles after transition is complete
    setTimeout(() => {
      if (this.targetOpen) {
        this.content.style.maxHeight = '';
        this.content.style.opacity = '';
        this.content.style.overflow = '';
        this.content.style.transition = '';
      }
    }, 310);
  }

  close() {
    this.targetOpen = false;
    this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    this.content.style.opacity = '1';
    this.content.style.overflow = 'hidden';
    this.content.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';

    setTimeout(() => {
      if (this.targetOpen) return;
      this.content.style.maxHeight = '0px';
      this.content.style.opacity = '0';
    }, 10);

    setTimeout(() => {
      if (!this.targetOpen) {
        this.el.open = false;
        this.content.style.maxHeight = '';
        this.content.style.opacity = '';
        this.content.style.overflow = '';
        this.content.style.transition = '';
      }
    }, 310);
  }
}

export function initAccordions(scope = document) {
  // 1. Initialize smooth animations for native <details> accordions inside accordion-custom
  const detailsList = scope.querySelectorAll(
    'accordion-custom details'
  );
  detailsList.forEach((el) => {
    if (el._accordionInstance) return;
    el._accordionInstance = new DetailsAccordion(el);
  });

  // 2. Initialize simple class-based toggles for div-based product accordions
  const productAccordions = scope.querySelectorAll('.product-info__accordion');
  productAccordions.forEach((acc) => {
    const title = acc.querySelector('.product-info__accordion-title');
    if (!title || acc._initialized) return;
    acc._initialized = true;

    title.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = acc.classList.contains('is-open');

      if (!isOpen) {
        // Exclusivity: Close all other product accordions
        productAccordions.forEach((other) => {
          if (other !== acc) {
            other.classList.remove('is-open');
            const otherTitle = other.querySelector('.product-info__accordion-title');
            if (otherTitle) {
              otherTitle.setAttribute('aria-expanded', 'false');
            }
          }
        });

        acc.classList.add('is-open');
        title.setAttribute('aria-expanded', 'true');
      } else {
        acc.classList.remove('is-open');
        title.setAttribute('aria-expanded', 'false');
      }
    });

    // Also support keyboard navigation (Enter and Space) on role="button"
    title.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        title.click();
      }
    });
  });
}
